<script setup lang="ts">
/**
 * One icon from the brand sprite. The ids there carry an `rf-` prefix; every
 * caller passing the bare name once meant no icon rendered at all.
 */
defineProps<{ name: string; size?: number }>()
</script>

<template>
  <svg :width="size ?? 24" :height="size ?? 24" aria-hidden="true" focusable="false">
    <use :href="`/icons/sprite.svg#rf-${name}`" />
  </svg>
</template>
